export const safeAreaInsets = {
  safeAreaInsetsTop: 0,
  safeAreaInsetsBottom: 0,
  safeAreaInsetsLeft: 0,
  safeAreaInsetsRight: 0,
};
